<div class="tw-flex tw-justify-end tw-mr-2">
  <button mat-icon-button (click)="dialogRef.close()">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>
@if (data.multiple) {
  <h4 id="title" class="tw-text-center tw-mb-16">Select {{data.kind}}</h4>
} @else {
  <h4 id="title" class="tw-text-center tw-mb-16">Select Default {{data.kind}}</h4>
}
<mat-tab-group class="borderless -small-labels">
  <mat-tab label="All {{data.kind}}s">
    <div class="tw-mt-[24px]">
      <div class="tw-px-[24px]">
        @if (getScrollingList()) {
          <search-filter
            [filterConfig]="filterConfig"
            [search]="_itemSelectorService.search"
            [doSearch]="getScrollingList().doSearch"
            class="tw-mb-[16px]"
          />
        }
        <folder-path
          [folderTree]="selectFolderDialogService.folderTree()"
          [folderId]="selectFolderDialogService.currentParentFolderId"
          (folderClicked)="enterFolder({ id: $event })"
          [rootName]="data.kind + 's'"
        />
        <mat-divider class="light tw-mb-[16px]"></mat-divider>
        <table class="tw-w-full">
          <thead>
            <tr class="list-header">
              <th>Name</th>
            </tr>
          </thead>
        </table>
      </div>
      <mat-dialog-content>
        @if (getScrollingList()) {
          <cdk-virtual-scroll-viewport itemSize="54" class="tw-max-h-[50vh] tw-min-h-[30vh] tw-w-[500px] tw-overflow-y-auto" #scrollViewport>
            <table class="tw-w-full tw-min-w-[480px]"
              rvSpinner="items-list-loader"
              [rvShowSpinner]="selectFolderDialogService.loading() || getScrollingList().loadingItems">
              <tbody>
                <ng-container *cdkVirtualFor="let item of items">
                  @let itemId = getItemId(item);

                  @if (item.isFolder) {
                    <tr (click)="enterFolder(item)">
                      <td class="folder">
                        <div class="tw-flex tw-items-center tw-gap-4">
                          <mat-icon class="tw-text-gray-500 tw-ml-[7px]" svgIcon="folder" />
                          <a
                            (click)="$event.stopPropagation(); enterFolder(item)"
                            (keydown.enter)="enterFolder(item)"
                            (keydown.space)="$event.preventDefault(); enterFolder(item)"
                            role="button"
                            class="madero-link tw-font-semibold u_ellipsis-lg"
                            tabindex="0"
                            [attr.aria-label]="'Open folder ' + item.name"
                          >
                            {{item.name}}
                          </a>
                        </div>
                      </td>
                    </tr>
                  } @else {
                    <tr>
                      <td class="item-name-cell">
                        <div class="tw-flex tw-justify-between tw-items-center">
                          <div class="tw-flex tw-items-center tw-gap-[4px]">
                            @if (data.multiple) {
                              <mat-checkbox 
                                id="item-selector-cb-{{itemId}}"
                                [checked]="_itemSelectorService.isSelected(item, false)"
                                [ariaChecked]="_itemSelectorService.isSelected(item, false)"
                                ariaCheckedElementId="item-selector-cb-{{itemId}}-input"
                                aria-labelledby="item-label-{{itemId}}"
                                (click)="_itemSelectorService.selectItem(item, false)"
                              />
                            }
                            <span 
                              class="tw-font-semibold tw-cursor-pointer" 
                              [class.tw-ml-[8px]]="!data.multiple" 
                              id="item-label-{{itemId}}"
                              (click)="selectItem(item)">
                              {{item.name}}
                            </span>
                          </div>
                          <button mat-button color="primary" [mat-dialog-close]="{action: 'edit', item: item}">Edit</button>
                        </div>
                      </td>
                    </tr>
                  }
                </ng-container>
                @if (items.length === 0 && !selectFolderDialogService.loading() && !getScrollingList().loadingItems) {
                  <tr>
                    <td class="tw-text-center tw-text-gray-500">
                      No {{data.kind}}s found
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </cdk-virtual-scroll-viewport>
        }
      </mat-dialog-content>
      <mat-divider class="light"></mat-divider>
    </div>
  </mat-tab>
  @if (data.multiple) {
    <mat-tab label="Selected {{data.kind}}s" [disabled]="selectedItems.length === 0">
      <div class="tw-mt-[24px] tw-px-[24px]">
        <table class="tw-w-full">
          <thead>
            <tr class="list-header">
              <th>Name</th>
            </tr>
          </thead>
        </table>
      </div>
      <mat-dialog-content class="tw-h-[50vh] tw-overflow-y-auto">
        <table class="tw-w-full tw-min-w-[480px]"
          rvSpinner="items-list-loader"
          [rvShowSpinner]="selectFolderDialogService.loading()">
          <tbody>
            @for (item of selectedItems; track item.id) {
              <tr>
                <td>
                  <div class="tw-flex tw-justify-between tw-items-center">
                    <div class="tw-flex tw-items-center tw-gap-[16px]">
                      @if (data.multiple) {
                        <mat-checkbox [checked]="_itemSelectorService.isSelected(item, true)"
                          (click)="_itemSelectorService.selectItem(item, true)" />
                      }
                      <span class="tw-font-semibold tw-cursor-pointer" (click)="selectItem(item, true)">
                        {{item.name}}
                      </span>
                    </div>
                    <button mat-button color="primary" [mat-dialog-close]="{action: 'edit', item: item}">Edit</button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </mat-dialog-content>
    </mat-tab>
  }
</mat-tab-group>
<mat-dialog-actions align="end" class="tw-p-[24px] tw-gap-[8px]">
  <button mat-stroked-button (click)="dialogRef.close()">Cancel</button>
  <button mat-stroked-button
    [mat-dialog-close]="{action: 'add'}"
    >
    Add {{data.kind}}
  </button>
  @if (data.multiple) {
    <button mat-flat-button
      color="primary"
      (click)="confirmSelection()"
      [disabled]="selectFolderDialogService.loading() || (!someItemIsSelected && !someSelectedItemIsUnselected)"
    >
      Select
    </button>
  }
</mat-dialog-actions>